import React,{useEffect, useRef} from 'react'

import { useState } from 'react'
import PartyForm from '../../../finance/party/components/PartyForm';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useAppData } from '../../../../../../context/AppDataContext';

import { Print } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import CRMLayout from '../../../../../../layout/components/CRMLayout';


//Copy of Finance Party Section page and using Everything from finance section

const CellActions = (props) =>{
    return(
        <>
            <Link to={`/party/details/${props.data.id}`}>{props.data.displayName}</Link>
            {/*
              <PartyForm  callBack={props.callBack} data={props.data} />
              <ConfirmDialog id={props.data.id} confirm={ ()=>props.remove(props.data.id)} >Are you Sure You want to remove</ConfirmDialog>
            */}
        </>
    )
  }


function CustomerListPage() {

  const {masters,getMasterLabel} = useAppData()
  const {partyList,getPartyList} = useAppData();
  const gridRef = useRef();
  

  const remove = () =>{

  }

  const [defaultColDef] = useState({
    floatingFilter: true,
    filterParams: {
      buttons: ['apply'],
    },
    resizable: true,
    width:120,
    filter:true,
    sortable: true,
    cellStyle: { 'textTransform': 'uppercase' },
  });


  const [columnDefs,setColumnDef] = useState();
    const prepairColumnDef = () => {
    let _columnDefs = [
        {field:"id",headerName: "ID"},
        {headerName:"Display Name", width:"200", valueGetter: params => params.data.title,
            cellRenderer: CellActions,
            cellRendererParams: {
                callBack:getPartyList,
                remove:remove
            },
        }, 
        {field:"contactPerson",headerName: "Contact Person",width:250},
        //{field:"Role",headerName: "Role",width:250, valueGetter: params => getMasterLabel("party-role",params.data.partyRole)},
        {field:"phone",headerName: "Phone"},
        {field:"email",headerName: "Email"},
             
    ];
    setColumnDef(_columnDefs);
  }

  const onBtnExport = () => {
    gridRef.current.api.exportDataAsCsv("data.csv");
  };

  useEffect(()=>{    
    prepairColumnDef();
  },[]);
  return (
    
    <CRMLayout>
      <div className='row'>
        <div className='col-md-3'><h4>Manage Customer / Party</h4></div>
        <div className='col-md-9'> 
          <span className='float-end'>
            {masters['party-role'].map(partyRole=>
              <span key={partyRole.value} className='me-2'><PartyForm callBack={getPartyList} partyRole={partyRole} /></span>
            )}
            
          </span>
          <button className='btn btn-warning me-2 float-end' onClick={onBtnExport} ><Print /> Export </button>
        </div>
        <div className='col-md-12 mt-2'>
          <div className="ag-theme-alpine" style={{height: 400}}>
            <AgGridReact
              ref={gridRef}
              rowData={partyList}
              columnDefs={columnDefs}
              defaultColDef={defaultColDef}
              animateRows={true}
              onGridReady={getPartyList}
            />
          </div>
        </div>
      </div>
    </CRMLayout>
    
  )
}

export default CustomerListPage